import React from 'react';
import { compose } from 'recompose';
import { Modal, Header, Icon, Button } from 'semantic-ui-react';
import { withLocale } from 'op/components/locale';

const FormWarningModal = ({ locale, open, onProceed, onCancel, warningLocaleKey }) => {
    return (
        <Modal open={open} basic size='small'>
        <Header icon='warning sign' content={locale[warningLocaleKey].header} />
        <Modal.Content>
            {locale[warningLocaleKey].content.map((item, index) => (
                <p key={index}>{item}</p>
            ))}
        </Modal.Content>
        <Modal.Actions>
            <Button basic color='red' onClick={onCancel} inverted>
                <Icon name='remove' /> {locale[warningLocaleKey].cancel}
            </Button>
            <Button color='green' onClick={onProceed} inverted>
                <Icon name='checkmark' /> {locale[warningLocaleKey].proceed}
            </Button>
        </Modal.Actions>
    </Modal>
    );
};

export default compose(
    withLocale("forms")
)(FormWarningModal);